export const metadataUIDeprecationMessage =
    "This metadata configuration UI is being deprecated. Use our new datasource configuration flow for a more flexible setup.";

export const metadataFieldDeprecationMessage =
    "Metadata 1-5 fields are being deprecated. Use our new datasource configuration flow for a more flexible setup.";
